/**
 * Format an ISO date string into a localized string with weekday, month, day, and time
 * @param isoString - The ISO date string to be formatted (e.g., "2025-01-18T20:00:00.000Z")
 * @param locales - The locales argument for localization. Defaults to `en-US`
 * @param options - Additional options for time formatting
 * @returns The formatted date as a string (e.g., "Tuesday, July 30: 7:00pm")
 */
export function getFormattedDateWithTime(
	isoString: string,
	locales: Intl.LocalesArgument = "en-US",
	options?: Intl.DateTimeFormatOptions
): string {
	const date = new Date(isoString);

	const datePart = date.toLocaleDateString(locales, {
		weekday: "long",
		month: "long",
		day: "2-digit",
		...options
	});

	const timePart = date.toLocaleTimeString(locales, {
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
		...options
	});

	return `${datePart}: ${timePart}`;
}
